<template>
  <div id="app">
    <transition name="pull-up">
      <router-view/>
    </transition>
    <my-tabbar></my-tabbar>
  </div>
</template>
<script>

import MyTabBar from './components/tabbar.vue';
import {initCartGoodsNum} from './api/carts'
import {initOrdersNum} from './api/order/submit'
import {initEnableWithholding} from './api/pay/index'
import {initUserName, initOps} from './api/user/index'

export default {
  components: {
    'my-tabbar': MyTabBar
  },
  mounted() {
    initCartGoodsNum();
    initOrdersNum();
    initEnableWithholding();
    initUserName();
    initOps();
  }
};
</script>
<style lang="less">
/**
* 覆盖 vant
 */
#app {
  //max-width: 960px;
  margin: 0 auto;
  img {
    width: 100%;
    height: 100%;
  }

  .van-nav-bar__text {
    color: #b6b6b6;
  }

  /**
  × 返回按钮
   */

  .van-nav-bar .van-icon {
    font-size: 16px;
    font-weight: 900;
    color: #b6b6b6;
  }

  .van-card {
    background: #fff;
  }

  /*        .van-card__footer {
              right: inherit;
          }*/

  .van-card__title {
    max-height: 20px;
  }

  .van-checkbox__icon--checked .van-icon, .van-radio__icon--checked .van-icon {
    color: #fff;
    background-color: #ff4545;
    border-color: #ff4545;
  }
}

/*    body {
        background: #fafafa;
    }*/

#app {

  .my-nav {
    background: #fff; //rgb(242, 242, 242);
    color: #666;
    box-shadow: 2px 2px 1px #f2f2f2;
    z-index: 10;
    /*box-shadow: 2px 2px 5px 2px #ddd;*/
  }
  .van-tabbar--fixed{
    //position: sticky;
  }
}


</style>
